import script from "./ConfigurationDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigurationDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigurationDeleteModal.vue?vue&type=style&index=0&id=4aa3c9b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa3c9b2"]])

export default __exports__